export const ERROR_PRESET = {
    unexpected: {
        title: 'Unexpected Error',
        message: 'An unexpected error has occurred.',
    },
    outOfStock: {
        title: 'Unable to add to cart',
        message: 'This item is currently out of stock. Please check back later.',
    },
    refreshNeeded: {
        title: 'Unexpected error has occurred',
        message: 'Please refresh page to continue.',
    },
} as const;
